import { useTranslation } from 'react-i18next';
import { Calendar, FileDown, MonitorPlay, TrendingUp, Utensils } from 'lucide-react';

// What Pro adds to the free plan, each with a line on what it does. The Alexa and the exercise library are left
// out: the free plan has them too.
const FEATURES = [
  { key: 'ai', mark: 'IA' },
  { key: 'split', Icon: Calendar },
  { key: 'ten', mark: '10' },
  { key: 'diet', Icon: Utensils },
  { key: 'progress', Icon: TrendingUp },
  { key: 'academy', Icon: MonitorPlay },
  { key: 'pdf', Icon: FileDown },
];

/**
 * A grouped list, one feature per row. className sets when it splits into two columns (styles/pages/conta.css):
 * mt-feats--two from 960px, mt-feats--two-wide from 1200px; mt-feats--span-last stretches an odd last row across.
 * labelledBy: the heading the list sits under.
 */
export const ProFeatureList = ({ labelledBy, className = '' }) => {
  const { t } = useTranslation();

  return (
    <ul className={`mt-glist mt-glist--icons mt-feats ${className}`.trim()} aria-labelledby={labelledBy}>
      {FEATURES.map(({ key, Icon, mark }) => (
        <li key={key} className="mt-glist__row">
          <span className="mt-glist__sq" aria-hidden="true">
            {mark ? <b className="mt-glist__mark">{mark}</b> : <Icon />}
          </span>
          <span className="mt-glist__k">
            <span className="mt-glist__title">{t(`pages.Plans.ui.features.${key}.title`)}</span>
            <span className="mt-glist__hint">{t(`pages.Plans.ui.features.${key}.desc`)}</span>
          </span>
        </li>
      ))}
    </ul>
  );
};
